var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7 6.33374C9.7 5.96006 10.0259 5.6 10.5 5.6H18.5C18.9741 5.6 19.3 5.96006 19.3 6.33374V7.06748H9.7V6.33374ZM20.9 6.33374V7.06748H23.3C25.0351 7.06748 26.5 8.42413 26.5 10.1681V20.9043C26.5 22.6483 25.0351 24.0049 23.3 24.0049H5.7C3.96491 24.0049 2.5 22.6483 2.5 20.9043V10.1681C2.5 8.42413 3.96491 7.06748 5.7 7.06748H8.1V6.33374C8.1 5.0133 9.20674 4 10.5 4H18.5C19.7933 4 20.9 5.0133 20.9 6.33374ZM8.9 8.66748H20.1H23.3C24.2159 8.66748 24.9 9.37088 24.9 10.1681V20.9043C24.9 21.7015 24.2159 22.4049 23.3 22.4049H5.7C4.78412 22.4049 4.1 21.7015 4.1 20.9043V10.1681C4.1 9.37088 4.78412 8.66748 5.7 8.66748H8.9ZM10.5 15.5362C10.5 13.4683 12.2586 11.7349 14.5 11.7349C16.7414 11.7349 18.5 13.4683 18.5 15.5362C18.5 17.604 16.7414 19.3374 14.5 19.3374C12.2586 19.3374 10.5 17.604 10.5 15.5362ZM14.5 10.1349C11.4394 10.1349 8.89999 12.5216 8.89999 15.5362C8.89999 18.5507 11.4394 20.9374 14.5 20.9374C17.5606 20.9374 20.1 18.5507 20.1 15.5362C20.1 12.5216 17.5606 10.1349 14.5 10.1349Z",
    fill: "#D70064"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0b04bd26.svg";
export { ForwardRef as ReactComponent };